import { ChangeRequestInput } from './interface';

export class GetAllRequests {
    static readonly type = '[ChangeRequests] all';
    constructor(
        public queryParams?: {
            formTitle?: string;
        }
    ) {}
}

export class CreateChangeRequest {
    static readonly type = '[ChangeRequests] create change-req';
    constructor(public input: ChangeRequestInput) {}
}

export class GetSingleChangeRequest {
    static readonly type = '[ChangeRequests] get-one';
    constructor(public id: string) {}
}
export class GetByUser {
    static readonly type = '[ChangeRequests] get-by-user';
    constructor(public input: { id: string; query: string }) {}
}
export class GetApproverRequests {
    static readonly type = '[ChangeRequests] approvers';
    constructor(public input: { id: string; query: string }) {}
}
export class GetChangeRequestApprovers {
    static readonly type = '[ChangeRequests] change-approvers';
    constructor(public input: { id: string; query: string }) {}
}
